import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export const appInsights = new ApplicationInsights({
  config: {
    // Application Insights Configuration
    instrumentationKey: process.env.GATSBY_APP_INSIGHTS_INSTRUMENTATION_KEY,
    connectionString: process.env.GATSBY_APP_INSIGHTS_CONNECTIION_STRING,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    correlationHeaderExcludedDomains: ['*.queue.core.windows.net'],
    disableTelemetry: false,
  },
});
